import { Button, TooltipTrigger } from '@toggle/design-system';
import React, { ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ChatInput } from '~/components/chat';
import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { useChatNavigation } from '~/views/alfred/use-chat-navigation/useChatNavigation';

import * as S from './AlfredFooter.styles';

export interface AlfredFooterProps {
  renderChatInput?: (override?: { cta?: ReactNode }) => ReactNode;
  onReload?: () => void;
  selectedBadges?: ReactNode[];
  ctaLabel?: string;
  onCtaClick?: () => void;
  isCtaLoading?: boolean;
  suggestedQuestion?: string;
  isLoading?: boolean;
  submitCallback?: (message?: string) => void;
  isActive?: boolean;
  emptyState?: boolean;
  shouldHide?: boolean;
  showReloadButton?: boolean;
}

export const AlfredFooter = ({
  onReload,
  suggestedQuestion,
  isLoading = false,
  submitCallback,
  isActive,
  emptyState = false,
  shouldHide = false,
  showReloadButton = false,
}: AlfredFooterProps) => {
  const { mode, setMode, resetPreviousMode } = useChatNavigation();
  const { t } = useTranslation(['chat']);

  useEffect(() => {
    if (mode !== 'research') {
      setMode('research');
    }

    resetPreviousMode();
  }, []);

  return (
    <S.AlfredFooterRoot $hide={shouldHide}>
      <S.LeftControls $hide={emptyState || !showReloadButton}>
        <TooltipContainer
          label={t('chat:reload')}
          trigger={[TooltipTrigger.Hover]}
        >
          <Button
            variant="empty"
            size="small"
            iconName="ArrowRotateRight"
            aria-label={t('chat:reload')}
            onClick={!isLoading ? onReload : undefined}
            isLoading={isLoading && isActive}
          />
        </TooltipContainer>
      </S.LeftControls>

      <S.InputRegion>
        <ChatInput
          config={{
            autoFocus: false,
            alfredEverywhere: true,
            suggestedValue: suggestedQuestion,
            allowedModes: ['document', 'research'],
          }}
          submitCallback={submitCallback}
        />
      </S.InputRegion>
    </S.AlfredFooterRoot>
  );
};
